import { OP_ROLE_ICON } from "@/lib/opIcons";
import { OP_SURFACE, type OpSurfaceTone } from "@/lib/opSurfaces";
import { cn } from "@/lib/utils";

export function OpRoleBadge({
  tone,
  label,
  className,
  showLabel = true,
  size = "sm",
}: {
  tone: OpSurfaceTone;
  label?: string;
  className?: string;
  showLabel?: boolean;
  size?: "sm" | "md";
}) {
  const meta = OP_SURFACE[tone];
  const { icon: Icon, iconClass } = OP_ROLE_ICON[tone];
  const family = meta.family;
  const chrome = meta.chrome;

  const iconSize =
    family === "focus" || size === "md"
      ? "h-4 w-4"
      : family === "ambient"
        ? "h-3 w-3"
        : "h-3.5 w-3.5";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-bold uppercase",
        // Focus: większy, mocniejszy tracking
        family === "focus" && "text-xs tracking-[0.14em]",
        // Work / default
        family === "work" && (size === "md" ? "text-xs tracking-wider" : "text-[10px] tracking-wider"),
        // IO
        family === "io" && (size === "md" ? "text-xs tracking-wider" : "text-[10px] tracking-wider"),
        // Live: lekko większy
        family === "live" && "text-[11px] tracking-wider",
        // Signal: najszerszy tracking (alarm)
        family === "signal" && "text-[10px] tracking-[0.2em]",
        // Ambient: mniejszy, spokojniejszy
        family === "ambient" && "text-[9px] font-semibold tracking-wide normal-case",
        // Machine: mono chip
        family === "machine" &&
          "rounded px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-normal normal-case bg-black/25",
        size === "md" && family !== "ambient" && family !== "machine" && "text-xs",
        meta.ink ?? "text-slate-800",
        className,
      )}
    >
      <Icon
        className={cn(
          iconSize,
          "shrink-0",
          iconClass,
          chrome === "live" && "animate-pulse",
        )}
        aria-hidden
      />
      {showLabel ? (
        <span>{label ?? meta.label}</span>
      ) : (
        <span className="sr-only">{label ?? meta.label}</span>
      )}
    </span>
  );
}
